import { authRoute } from "./auth";
import { signinRoute } from "./signin";
import { signupRoute } from "./signup";
import { forgotPasswordRoute } from "./forgot-password";
import { resetPasswordRoute } from "./reset-password";
import { verifyEmailRoute } from "./verify-email";
import { activeEmailRoute } from "./active-email";
import { setupPasswordRoute } from "./setup-password";

export const allAuthRoute = [
  authRoute(),
  signinRoute(),
  signupRoute(),
  forgotPasswordRoute(),
  resetPasswordRoute(),
  verifyEmailRoute(),
  activeEmailRoute(),
  setupPasswordRoute()
];
